import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgTrash from 'components/svg/SvgTrash';
import type { VendorType } from '@econtractor/types';

const useDeleteVendor = () => {
    const { t } = useTranslation(['Vendors']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons: [...getButtonsNoYesDanger(t)],
        type: 'confirm',
    };

    const deleteVendor = (vendor: VendorType, cbFunct: () => void) => {
        const p = {
            ...paramsDelDlg,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom text-danger">
                        <SvgTrash className="text-danger" />
                        <span className="ps-2">{t('vendorPopup.delete')}?</span>
                    </h4>
                    <h5 className="mb-0">{vendor.vendorName}</h5>
                </>
            ),
        };

        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    return {
        deleteVendor,
    };
};

export default useDeleteVendor;
